import React from 'react';
import {Link, Typography} from '@material-ui/core';
import {ReactComponent as Logo} from '../assets/logo.svg';
import { __ } from '../lib/localization';
import Views from '../lib/views';

const Footer = (props) => {
    const onLogoClick = () => {
        props.Analytics.trackEvent('link', 'leadferno');
        window.open('https://leadferno.com', '_blank');
    }

    const onLogoKeypress = event => {
        if (event.key === 'Enter') {
            onLogoClick();
        }
    }

    return (
        <div>
            <div className={props.classes.form__footer}>
                <div className={props.classes.footerContainer}>
                    <Typography className={props.classes.formfooter__text}>
                        <Link
                            href="https://leadferno.com/acceptable-use-policy"
                            target="_blank"
                            className={props.classes.termsLink}
                            onClick={ () => { props.Analytics.trackEvent('link', 'use-policy') }}
                        >
                            { __('leadbox_terms_link') }
                        </Link>
                    </Typography>
                    <span style={{color: "#A8A8A8"}}>•</span>
                    <Logo
                        aria-role="Link"
                        aria-label={ __('leadbox_aria_leadferno_logo') }
                        tabindex="0"
                        className={props.classes.footerLogo}
                        onClick={onLogoClick}
                        onKeyPress={onLogoKeypress}
                    />
                    <span style={{color: "#A8A8A8"}}>•</span>
                    <Typography className={props.classes.formfooter__text}>
                        <Link
                            href="javascript:void(0)"
                            target="_blank"
                            className={props.classes.termsLink}
                            onClick={ e => { e.preventDefault(); props.setView(Views.smsPrivacyPolicy); props.Analytics.trackEvent('link', 'privacy-policy') }}
                        >
                            { __('leadbox_privacy_link') }
                        </Link>
                    </Typography>
                </div>
            </div>
        </div>
    )
}

export default Footer;
